export enum ChatKey {
  CHAT = 'chat',
  CHAT_FILE_UPLOAD = 'uploadChatFile',
  CHAT_LAST_CONVERSATIONS_INFINITE = 'lastConversationsInfinite',
  CHAT_CONVERSATIONS_USERS_INFINITE = 'conversationUsersInfinite',
}
